import { c as _c } from "react/compiler-runtime";
import { Tooltip, centsToUnits, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import { TransactionInterface } from 'modules/payment/transactions/types/transaction-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface AmountTooltipProps {
  transaction: TransactionInterface;
}
const TransactionAmountTooltip = t0 => {
  const $ = _c(73);
  const {
    transaction
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const pricePlan = transaction.payment.paymentItems[0]?.orderItem.pricePlan;
  let T0;
  let shippingFee;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== pricePlan?.innerName || $[1] !== t || $[2] !== transaction.payment.currency || $[3] !== transaction.payment.paymentItems[0]?.orderItem.productOrderItem?.shippingCondition?.price || $[4] !== transaction.payment.tax || $[5] !== transaction.payment.total || $[6] !== user?.dashboardLocale) {
    const tax = centsToUnits(transaction.payment.tax);
    shippingFee = transaction.payment.paymentItems[0]?.orderItem.productOrderItem?.shippingCondition?.price;
    T0 = Tooltip;
    t5 = "hover";
    t6 = "w-full max-w-fit truncate";
    t7 = "w-full";
    t3 = "flex flex-col items-start gap-2";
    let t8;
    if ($[16] !== transaction.payment.currency || $[17] !== transaction.payment.total || $[18] !== user?.dashboardLocale) {
      t8 = currencyFormat(centsToUnits(transaction.payment.total), transaction.payment.currency, user?.dashboardLocale);
      $[16] = transaction.payment.currency;
      $[17] = transaction.payment.total;
      $[18] = user?.dashboardLocale;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    let t9;
    if ($[20] !== t) {
      t9 = t("dashboard.transactions.for").toLowerCase();
      $[20] = t;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    const t10 = pricePlan?.innerName;
    let t11;
    if ($[22] !== t10) {
      t11 = <span className="font-bold">{t10}</span>;
      $[22] = t10;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    if ($[24] !== t11 || $[25] !== t8 || $[26] !== t9) {
      t4 = <p>{t8}{" "}{t9}{" "}{t11}</p>;
      $[24] = t11;
      $[25] = t8;
      $[26] = t9;
      $[27] = t4;
    } else {
      t4 = $[27];
    }
    let t12;
    if ($[28] !== t) {
      t12 = t("dashboard.transactions.vat");
      $[28] = t;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    if ($[30] !== t12) {
      t1 = <span className="text-text-primary font-bold">{t12}: </span>;
      $[30] = t12;
      $[31] = t1;
    } else {
      t1 = $[31];
    }
    t2 = currencyFormat(tax, transaction.payment.currency, user?.dashboardLocale);
    $[0] = pricePlan?.innerName;
    $[1] = t;
    $[2] = transaction.payment.currency;
    $[3] = transaction.payment.paymentItems[0]?.orderItem.productOrderItem?.shippingCondition?.price;
    $[4] = transaction.payment.tax;
    $[5] = transaction.payment.total;
    $[6] = user?.dashboardLocale;
    $[7] = T0;
    $[8] = shippingFee;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    T0 = $[7];
    shippingFee = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[32] !== t1 || $[33] !== t2) {
    t8 = <p>{t1}{t2}</p>;
    $[32] = t1;
    $[33] = t2;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== shippingFee || $[36] !== t || $[37] !== transaction.payment.currency || $[38] !== user?.dashboardLocale) {
    t9 = shippingFee && <p><span className="text-text-primary font-bold">{t("dashboard.products.shipping.title")}:{" "}</span>{currencyFormat(centsToUnits(shippingFee), transaction.payment.currency, user?.dashboardLocale)}</p>;
    $[35] = shippingFee;
    $[36] = t;
    $[37] = transaction.payment.currency;
    $[38] = user?.dashboardLocale;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== t) {
    t10 = t("dashboard.transactions.payment_processor");
    $[40] = t;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== t10) {
    t11 = <span className="text-text-primary font-bold">{t10}:{" "}</span>;
    $[42] = t10;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  let t12;
  if ($[44] !== tUi || $[45] !== transaction.payment.paymentProcessorName) {
    t12 = getPaymentProcessorTitle(transaction.payment.paymentProcessorName, tUi);
    $[44] = tUi;
    $[45] = transaction.payment.paymentProcessorName;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] !== t11 || $[48] !== t12) {
    t13 = <p>{t11}{t12}</p>;
    $[47] = t11;
    $[48] = t12;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  let t14;
  if ($[50] !== t || $[51] !== transaction.coupon || $[52] !== user?.dashboardLocale) {
    t14 = transaction.coupon && <p><span className="text-text-primary font-bold">{t("dashboard.transactions.coupon")} {`«${transaction.coupon.innerName}»`}:{" "}</span>{transaction.coupon.discountType === "percent" ? `${transaction.coupon.discountAmount}%` : currencyFormat(centsToUnits(transaction.coupon.discountAmount), transaction.coupon.currency, user?.dashboardLocale)}</p>;
    $[50] = t;
    $[51] = transaction.coupon;
    $[52] = user?.dashboardLocale;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  let t15;
  if ($[54] !== t13 || $[55] !== t14 || $[56] !== t3 || $[57] !== t4 || $[58] !== t8 || $[59] !== t9) {
    t15 = <div className={t3}>{t4}{t8}{t9}{t13}{t14}</div>;
    $[54] = t13;
    $[55] = t14;
    $[56] = t3;
    $[57] = t4;
    $[58] = t8;
    $[59] = t9;
    $[60] = t15;
  } else {
    t15 = $[60];
  }
  let t16;
  if ($[61] !== transaction.payment.currency || $[62] !== transaction.payment.total || $[63] !== transaction.refund || $[64] !== user?.dashboardLocale) {
    t16 = <div className="text-text-primary cursor-default truncate">{transaction.refund ? <span>-{" "}{currencyFormat(centsToUnits(transaction.payment.total), transaction.payment.currency, user?.dashboardLocale)}</span> : <span>+{" "}{currencyFormat(centsToUnits(transaction.payment.total), transaction.payment.currency, user?.dashboardLocale)}</span>}</div>;
    $[61] = transaction.payment.currency;
    $[62] = transaction.payment.total;
    $[63] = transaction.refund;
    $[64] = user?.dashboardLocale;
    $[65] = t16;
  } else {
    t16 = $[65];
  }
  let t17;
  if ($[66] !== T0 || $[67] !== t15 || $[68] !== t16 || $[69] !== t5 || $[70] !== t6 || $[71] !== t7) {
    t17 = <T0 mode={t5} className={t6} wrapperClassName={t7} label={t15}>{t16}</T0>;
    $[66] = T0;
    $[67] = t15;
    $[68] = t16;
    $[69] = t5;
    $[70] = t6;
    $[71] = t7;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  return t17;
};
export default TransactionAmountTooltip;